module.exports = __webpack_public_path__ + "static/media/projectTimeRecord.a9078c85.jpg";